export const RQ_GET_WHATSAPP_CONSENT_API = {
  url: 'consentdetails/getWhatsappConsentReport/<%= locationId %>',
  method: 'GET',
  auth: true,
};
